import { Group, Stack } from "@mantine/core"

import { ActivityTitle } from "~/pages/SupplierPortal/TraceabilityRequests/components/ActivityTitle.tsx"

import { OperationItemInformation } from "./OperationItemInformation"

export const OperationInfo = () => {
  return (
    <Stack justify="flex-start" align="flex-start" w="100%">
      <Group>
        <ActivityTitle />
      </Group>
      <OperationItemInformation />
    </Stack>
  )
}
